import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { AppNav } from "@/components/AppNav";
import { listPosts, fmtDate } from "@/lib/blog";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Blog — Busca Blindados" },
      { name: "description", content: "Análises de mercado, guias sobre blindagem e o que aprendemos monitorando 60+ sites de blindados todo dia." },
    ],
  }),
  component: BlogIndex,
});

function BlogIndex() {
  const posts = listPosts();
  return (
    <div className="min-h-screen text-foreground">
      {/* Nav stretches to match the home + SEO pages (max-w-6xl) so clicking
          "Blog" doesn't visually squeeze the top bar. The reading column below
          stays at max-w-3xl for line-length readability (~80ch). */}
      <AppNav maxWidth="max-w-6xl" />
      <main className="mx-auto max-w-3xl px-6 pb-32 pt-6">
        <header className="mb-10">
          <h1 className="font-display text-3xl text-foreground sm:text-4xl">Blog</h1>
          <p className="mt-3 text-[15px] text-muted-foreground">
            Análises de mercado, guias práticos e o que aprendemos monitorando 60+ sites de blindados todo dia.
          </p>
        </header>

        {posts.length === 0 ? (
          <p className="text-sm text-muted-foreground">Em breve.</p>
        ) : (
          <ul className="space-y-4">
            {posts.map((p) => (
              <li key={p.meta.slug}>
                <Link
                  to="/blog/$slug"
                  params={{ slug: p.meta.slug }}
                  className="surface-card group block rounded-2xl p-6 transition-all duration-150 hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10"
                >
                  <p className="text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                    {fmtDate(p.meta.date)}
                  </p>
                  <h2 className="mt-1 font-display text-xl text-foreground group-hover:text-primary">
                    {p.meta.title}
                  </h2>
                  <p className="mt-2 text-sm text-muted-foreground">{p.meta.description}</p>
                  <p className="mt-3 inline-flex items-center gap-1 text-xs text-muted-foreground group-hover:text-foreground/70">
                    Ler post <ArrowRight className="h-3 w-3" />
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
